import { render } from "./AdminDeleteModal.vue?vue&type=template&id=d166a88a"
import script from "./AdminDeleteModal.vue?vue&type=script&lang=js"
export * from "./AdminDeleteModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__